import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
import { Link } from 'react-router-dom';
import { PageHeader } from '../components/PageHeader';
import { CtaBand } from '../components/CtaBand';
import { ResumeTiers } from '../components/ResumeTiers';
import { services } from '../data/services';
import { audiences, methodology } from '../data/experience';
export function Services() {
  return <>
      <PageHeader label="Advisory Services" title="Precision career strategy for senior leaders and the boardroom." intro="Each service can stand alone or combine into a comprehensive engagement. Every deliverable is written and advised personally by Dr. Vecchione — never outsourced." data-id="element-328" data-mp="15bwq7ym85b9" />

      <ResumeTiers data-id="element-329" data-mp="65zlso3aac2u" />

      {/* Services detail */}
      <section className="border-t border-hairline bg-white" aria-label="Services" data-id="element-330" data-mp="2cvea5z6lalaw">
        <div className="mx-auto max-w-7xl px-6 py-12 lg:px-8 lg:py-16" data-id="element-331" data-mp="2cxie2h4hnkb6">
          {services.map(s => <article key={s.id} id={s.id} className="grid scroll-mt-28 gap-8 border-b border-hairline py-14 last:border-b-0 lg:grid-cols-12 lg:gap-12 lg:py-20" data-id="element-332" data-mp="27ynwfii9c1sn">
              <div className="lg:col-span-4" data-id="element-333" data-mp="1fprad95zfyff">
                <s.icon className="h-7 w-7 text-gold" strokeWidth={1.5} aria-hidden="true" data-id="element-334" data-mp="1fny43uza7g7y" />
                <h2 className="mt-6 font-serif text-2xl leading-snug text-navy lg:text-[1.75rem]" data-id="element-335" data-mp="1kh0yu6fsovpq">{s.title}</h2>
                <p className="mt-4 text-sm text-steel" data-id="element-336" data-mp="1pestv9bqkxy5">
                  <span className="font-semibold text-charcoal" data-id="element-337" data-mp="1udvu8ggrufzs">Ideal for: </span>
                  {s.audience}
                </p>
              </div>
              <div className="lg:col-span-5" data-id="element-338" data-mp="1ze9x7k3imzqy">
                <p className="text-lg leading-relaxed text-charcoal" data-id="element-339" data-mp="23flmfoih9iym">{s.description}</p>
                <Link to={s.id === 'resume' ? '/services#packages' : '/contact'} className="mt-8 inline-flex items-center gap-2 text-sm font-semibold text-navy underline decoration-gold underline-offset-[6px] hover:decoration-2" data-id="element-340" data-mp="4zqsdavi4k5r">
                  {s.id === 'resume' ? 'View resume packages' : 'Request this engagement'}
                  <ArrowRightIcon className="h-4 w-4" aria-hidden="true" data-id="element-341" data-mp="17f83l6io7ryj" />
                </Link>
              </div>
              <div className="lg:col-span-3" data-id="element-342" data-mp="1hb2usq0ymvcx">
                <h3 className="text-sm font-semibold text-navy" data-id="element-343" data-mp="1ha9v290f564a">What you receive</h3>
                <ul className="mt-4 space-y-3" data-id="element-344" data-mp="1v9sorwshgex2">
                  {s.deliverables.map(d => <li key={d} className="flex gap-3 text-[15px] leading-snug text-steel" data-id="element-345" data-mp="1qapv18hydv4e">
                      <span className="mt-2 h-px w-3 shrink-0 bg-gold" aria-hidden="true" data-id="element-346" data-mp="250x3qwi5rzrw" />
                      {d}
                    </li>)}
                </ul>
              </div>
            </article>)}
        </div>
      </section>

      {/* Engagement framework */}
      <section className="border-y border-hairline bg-ivory" aria-labelledby="framework-heading" data-id="element-347" data-mp="2930hjrsavggc">
        <div className="mx-auto max-w-7xl px-6 py-24 lg:px-8 lg:py-28" data-id="element-348" data-mp="2snr9v69s57be">
          <h2 id="framework-heading" className="max-w-2xl font-serif text-3xl leading-tight text-navy sm:text-4xl" data-id="element-349" data-mp="2xn3x3s4kcgei">
            How every engagement unfolds.
          </h2>
          <ol className="mt-16 grid gap-px overflow-hidden border border-hairline bg-hairline md:grid-cols-3" data-id="element-350" data-mp="2jpfaaeqxqz6t">
            {methodology.map(m => <li key={m.step} className="flex flex-col bg-white p-8 lg:p-10" data-id="element-351" data-mp="29x9gczh4i7oz">
                <span className="font-serif text-3xl text-gold" data-id="element-352" data-mp="2enzq0owl0wph">{m.step}</span>
                <h3 className="mt-6 font-serif text-xl text-navy" data-id="element-353" data-mp="2eq2q61rg867x">{m.title}</h3>
                <p className="mt-3 flex-1 text-[15px] leading-relaxed text-steel" data-id="element-354" data-mp="2016ezvu3id33">{m.summary}</p>
                <ul className="mt-8 space-y-2 border-t border-hairline pt-6 text-sm text-charcoal" data-id="element-355" data-mp="24ypuez2j4vwm">
                  {m.details.map(d => <li key={d} className="flex gap-3" data-id="element-356" data-mp="1vy9uu0owq8x1">
                      <span className="mt-2 h-px w-3 shrink-0 bg-gold" aria-hidden="true" data-id="element-357" data-mp="1vzuozp7b7pud" />
                      {d}
                    </li>)}
                </ul>
              </li>)}
          </ol>
        </div>
      </section>

      {/* Who I serve */}
      <section className="bg-white" aria-labelledby="serve-heading" data-id="element-358" data-mp="1e5ps0iewd4ul">
        <div className="mx-auto grid max-w-7xl gap-12 px-6 py-24 lg:grid-cols-12 lg:px-8 lg:py-28" data-id="element-359" data-mp="1a6gvj5sh2svc">
          <div className="lg:col-span-4" data-id="element-360" data-mp="156uiawcn9cmj">
            <h2 id="serve-heading" className="font-serif text-3xl leading-tight text-navy sm:text-4xl" data-id="element-361" data-mp="154hs5vwqfvye">
              Who this advisory serves.
            </h2>
            <p className="mt-5 leading-relaxed text-steel" data-id="element-362" data-mp="v9g473e70zxe">
              Engagements are selective and tailored to leaders whose next move carries significant consequence.
            </p>
          </div>
          <dl className="grid gap-x-12 sm:grid-cols-2 lg:col-span-8" data-id="element-363" data-mp="2pleaoxl4bhpl">
            {audiences.map(a => <div key={a.title} className="border-t border-hairline py-8" data-id="element-364" data-mp="2lm5hpuxwjnv3">
                <dt className="font-serif text-xl text-navy" data-id="element-365" data-mp="7duwhu3l7utt">{a.title}</dt>
                <dd className="mt-3 text-[15px] leading-relaxed text-steel" data-id="element-366" data-mp="cbwesct6vq48">{a.description}</dd>
              </div>)}
          </dl>
        </div>
      </section>

      <CtaBand data-id="element-367" data-mp="h4zaorlfvbnl" />
    </>;
}